import axios from 'axios';
import * as Config from '../../config';

const state = {
    typesDocument: {},
    typeDocument: {},
};

const actions = {

    load_TypesDocument({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'type/document/list/all')
                .then(
                    response => {
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_TypeDocument({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'type/document/consult/' + form.id)
                .then(
                    response => {
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    new_TypeDocument({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'type/document/store', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeActive_TypeDocument({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'type/document/change/active/' + form.id + '/' + form.active)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_TypeDocument({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'type/document/update/' + form.id, form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    }
};

const mutations = {

};

export default {
    state,
    actions,
    mutations
};